import FormSelect from 'components/Select/FormSelect';
import { IItemForGetShortInfo, IGetGamesShortResponse, IGetGamesShort } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import { getGamesShortInfo } from 'backend/games';
import React, { useEffect } from 'react';

interface IGameNameSelect {
	selectedRestaurants: string[];
	selectedTransitionGameCategory: Nullable<string>;
	setTransitionGameName: (value: Nullable<string>) => void;
	setFetchedGames: (value: IItemForGetShortInfo[]) => void;
}

const GameNameSelect: React.FC<IGameNameSelect> = ({
	selectedRestaurants,
	selectedTransitionGameCategory,
	setTransitionGameName,
	setFetchedGames,
}) => {
	const { response, loading, refetch, responseError } = useFetchData<IGetGamesShortResponse, IGetGamesShort>(
		selectedTransitionGameCategory && selectedRestaurants.length ? getGamesShortInfo : null,
		{
			gameCategoryId: selectedTransitionGameCategory || '',
			restaurantIds: selectedRestaurants,
		},
	);

	useEffect(() => {
		refetch();
	}, [selectedTransitionGameCategory]);

	useEffect(() => {
		response && setFetchedGames(response.data.games);
	}, [response]);

	return (
		<FormSelect
			testId="GameNameSelect"
			name="selectedTransitionGameName"
			label="gameLabel"
			disabled={!selectedTransitionGameCategory || loading}
			options={response?.data.games}
			fetchError={responseError}
			loading={loading}
			onRefetch={refetch}
			onChange={setTransitionGameName}
		/>
	);
};

export default React.memo(GameNameSelect);
